import * as React from 'react';
import type { SVGProps } from 'react';
const SvgRocket = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 14 14"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.04167 8.3558L6.70833 10.2089V11.1215C6.70833 11.2322 6.82682 11.3026 6.924 11.2495L8.96567 10.1359C9.01252 10.1104 9.04167 10.0612 9.04167 10.0079V8.3558ZM5.83333 10.1789L3.8211 8.16667H2.87848C2.10361 8.16667 1.61125 7.33726 1.9823 6.65701L3.09593 4.61534C3.27482 4.28739 3.61855 4.08333 3.99212 4.08333H6.3595C7.88146 2.4637 9.58096 1.36443 11.7783 1.19073C12.3676 1.14414 12.8559 1.63236 12.8093 2.22173C12.6356 4.41904 11.5363 6.11854 9.91667 7.6405V10.0079C9.91667 10.3814 9.71262 10.7252 9.38466 10.9041L7.343 12.0177C6.66274 12.3888 5.83333 11.8964 5.83333 11.1215V10.1789ZM5.6442 4.95833H3.99212C3.93875 4.95833 3.88965 4.98748 3.86409 5.03433L2.75046 7.076C2.69745 7.17318 2.76779 7.29167 2.87848 7.29167H3.79108L5.6442 4.95833Z"
      fill="currentColor"
    />
    <path
      d="M1.16578 11.1968C1.16578 10.2929 1.8985 9.56022 2.80235 9.56022C3.70621 9.56022 4.43893 10.2929 4.43893 11.1968C4.43893 12.1006 3.70621 12.8334 2.80235 12.8334H1.60328C1.36165 12.8334 1.16578 12.6375 1.16578 12.3959V11.1968Z"
      fill="currentColor"
    />
  </svg>
);
export default SvgRocket;
